const EmptyRouterView = () => import(/* webpackChunkName: "group-debug" */ '@/components/quickytools/empty-router-view')
const DebugUnity = () => import(/* webpackChunkName: "group-debug" */ '@/components/unity3d/debug-isolate-unity.vue')
const DebugKeyframeTimeline = () => import(/* webpackChunkName: "group-debug" */ '@/components/keyframeTimeline/isolate-keyframe-timeline.vue')

export default {
  path: '/debug-app',
  component: EmptyRouterView,

  children: [{
    path: 'unity',
    component: DebugUnity
  },
  {
    path: 'keyframe-timeline',
    component: DebugKeyframeTimeline
  }]
}
